import styled from '@emotion/styled';
import { BucketId, FileReferenceId } from '@kaizenplatform/belfast-entity';
import { createElement, useState } from 'react';

import { SPACING_UNIT } from '../../../constant/spacing';
import BatchDownloadButton from '../FileList/BatchDownloadButton';

type Props = {
  bucketId?: BucketId;
  fileIds?: ReadonlyArray<FileReferenceId>;
  onClickBatchDownloadButton: (downloadTarget: {
    bucketId?: BucketId;
    fileIds?: ReadonlyArray<FileReferenceId>;
  }) => void;
};

const BatchDownload = ({ bucketId, fileIds, onClickBatchDownloadButton }: Props) => {
  const [downloadLoading, setDownloadLoading] = useState(false);

  return (
    <ButtonWithIconContainer>
      <BatchDownloadButton
        onClick={async () => {
          setDownloadLoading(true);
          if (bucketId != null) {
            onClickBatchDownloadButton({ bucketId });
          } else if (fileIds != null) {
            onClickBatchDownloadButton({ fileIds });
          }
          setTimeout(() => {
            setDownloadLoading(false);
          }, 5 * 60 * 1000);
        }}
        disabled={downloadLoading}
      />
    </ButtonWithIconContainer>
  );
};

const ButtonWithIconContainer = styled('div')({
  display: 'flex',
  paddingRight: SPACING_UNIT,
  paddingBottom: SPACING_UNIT,
});

export default BatchDownload;
